import React from 'react';

export default () => (
    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66667 5.00016V7.50016L10 4.16683L6.66667 0.833496V3.3335C2.98333 3.3335 0 6.31683 0 10.0002C0 11.3085 0.383333 12.5252 1.03333 13.5502L2.25 12.3335C1.8644 11.6164 1.66389 10.8144 1.66667 10.0002C1.66667 7.24183 3.90833 5.00016 6.66667 5.00016ZM12.3 6.45016L11.0833 7.66683C11.45 8.36683 11.6667 9.15849 11.6667 10.0002C11.6667 12.7585 9.425 15.0002 6.66667 15.0002V12.5002L3.33333 15.8335L6.66667 19.1668V16.6668C10.35 16.6668 13.3333 13.6835 13.3333 10.0002C13.3333 8.69183 12.95 7.47516 12.3 6.45016Z" fill="#8B959E" />
    </svg>
)
